import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackAndNavigate } from '../utils/metaPixel';
export const CHECKOUT_URL = 'https://mapa-mental-ingles.impultienda.ar/checkout';
const includedItems = [{
  title: 'KIT +300 MAPAS MENTALES A1-C2',
  value: '$19990'
}, {
  title: '3 Bonos Exclusivos',
  value: '$37000'
}];
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-title" className="bg-cream" data-id="element-134" data-mp="dfygwudklsy2">
      <div className="mx-auto max-w-2xl px-5 py-20 lg:py-24" style={{
      backgroundColor: "#FFFFFF",
      backgroundImage: "none"
    }} data-id="element-135" data-mp="icynd6ec0xpp">
        <h2 id="oferta-title" className="text-center font-display text-3xl font-black leading-[1.1] text-ink sm:text-4xl" data-id="element-136" data-mp="rdem62k4rgo8">
          <span aria-hidden="true" data-id="element-137" data-mp="wbyauaq3z6ka">🏆 </span>Oferta especial de lanzamiento
        </h2>

        <div className="relative mt-12 rounded-3xl border border-coral px-4 pb-8 pt-12 sm:px-10 sm:pb-9" data-id="element-138" data-mp="2t62ugqbmsuav">
          <span className="absolute -top-[0.85rem] left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-coral px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-cream" data-id="element-139" data-mp="2y5ffd5ixzrat">
            Kit +300 mapas mentales
          </span>

          <ul className="divide-y divide-line" data-id="element-140" data-mp="xupaf2zlvdk1">
            {includedItems.map(item => <li key={item.title} className="flex items-baseline justify-between gap-3 py-5 sm:gap-6" data-id="element-141" data-mp="sy8h7udju903">
                <span className="text-[13px] leading-snug text-muted sm:text-sm" data-id="element-142" data-mp="oxyfitwsi4r1">{item.title}</span>
                <span className="shrink-0 text-sm font-semibold text-coral" data-id="element-143" data-mp="1lll6icb3gux3">{item.value}</span>
              </li>)}
            <li className="flex items-baseline justify-between gap-3 border-t border-line py-5 sm:gap-6" data-id="element-144" data-mp="1gl6uykaab2ub">
              <span className="text-[13px] font-bold uppercase tracking-[0.08em] text-ink sm:text-sm" data-id="element-145" data-mp="1cnj0tjgf1e3h">Valor total:</span>
              <span className="shrink-0 text-sm font-semibold text-coral line-through" data-id="element-146" data-mp="169jb2gukw4t">$56990</span>
            </li>
          </ul>

          <div className="flex flex-col items-center gap-3 pt-8 text-center" data-id="element-147" data-mp="3sbsu83b14rd9">
            <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-coral" data-id="element-148" data-mp="3tthkkg5xie0z">Solo por hoy</span>
            <p className="font-display text-4xl font-black leading-none text-coral sm:text-6xl" data-id="element-149" data-mp="2nyafhjkmmtl">
              <span aria-hidden="true" data-id="element-150" data-mp="3ku3140o6j3pz">🏆 </span>$19990
            </p>
          </div>

          <p className="mt-8 border-t border-line pt-6 text-center text-xs text-muted" data-id="element-151" data-mp="3ouddbv2keqda">
            <span aria-hidden="true" data-id="element-152" data-mp="3b3rs3zpn24c8">💳 </span>Pago único, acceso de por vida. Sin suscripción.
          </p>

          <a href={CHECKOUT_URL} onClick={event => trackAndNavigate(event, CHECKOUT_URL, 'InitiateCheckout', {
          content_name: 'Kit +300 Mapas Mentales',
          content_ids: ['kit-300-mapas-mentales'],
          content_type: 'product',
          value: 19990,
          currency: 'ARS'
        })} className="group mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-coral px-5 py-4 text-center text-[12px] font-bold uppercase leading-tight tracking-[0.08em] text-cream sm:gap-3 sm:px-8 sm:py-5 sm:text-sm sm:tracking-[0.1em] shadow-cta transition-[transform,background-color] duration-150 ease-out-expo hover:-translate-y-0.5 hover:bg-coral-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink" data-id="element-153" data-mp="3fuqdhdphhsmc">
            Consigue el Kit +300 Mapas Mentales
            <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-154" data-mp="2ig8mxmzq44av" />
          </a>

          <p className="mt-6 text-center text-xs text-muted" data-id="element-155" data-mp="2ri83yfaqn8dt">
            Descarga instantánea · Pago único · Acceso de por vida · Garantía por 7 días
          </p>
        </div>
      </div>
    </section>;
}